import { cloneDeep } from 'lodash';
import { fftColors, fftColorsMSR, fftSignals, PiezoSensor } from './constants';
import { chartColors } from 'helpers/constants';
import { translate } from 'helpers/translateHelper';
import { BEARING_TYPES } from 'sharedComponents/Chart/constants';

// Maintain selected FFT timestamps betweeen assets and organizations.
export const setMaintainedTimestamps = (selectedTimestamps, { timestamps, selectedAsset, selectedOrganization }) => {
    const getMaintainSelectedTimestamps = cloneDeep(selectedTimestamps);
    const assetId = selectedAsset?.id, organizationID = selectedOrganization?.organizationID;
    // Verify all ID's are available
    if (getMaintainSelectedTimestamps && assetId && organizationID) {
        if (getMaintainSelectedTimestamps[organizationID]) {
            getMaintainSelectedTimestamps[organizationID][assetId] = timestamps;
        } else {
            getMaintainSelectedTimestamps[organizationID] = {
                [assetId]: timestamps
            };
        }
    }
    return getMaintainSelectedTimestamps;
};

// Get Maintained FFT timestamps betweeen assets and organizations.
export const getMaintainedTimestamps = (maintainSelectedTimestamps, asset, selectedOrganization) => {
    const assetId = asset?.id, organizationID = selectedOrganization?.organizationID;
    if (maintainSelectedTimestamps && assetId && organizationID) {
        if (maintainSelectedTimestamps[organizationID] && maintainSelectedTimestamps[organizationID][assetId]) {
            return maintainSelectedTimestamps[organizationID][assetId];
        }
    }
    return [];
};

// Helper function to check if item should be processed
export const shouldProcessItem = (spectrumRangeSelection, item) => {
    return spectrumRangeSelection === PiezoSensor.id && item.sensorAxisName === PiezoSensor.axisName ||
        spectrumRangeSelection !== PiezoSensor.id && item.sensorAxisName !== PiezoSensor.axisName;
};

// Helper function to determine visibility based on timestamp count
export const determineVisibility = (timestampLegends, signalName, timestampCount, signalCount) => {
    let visible = timestampLegends?.visible !== false ? timestampLegends[signalName] !== false : false;

    if (timestampLegends?.visible !== false && timestampLegends[signalName] === undefined) {
        if (timestampCount >= 4 && timestampCount <= 6) {
            visible = signalCount === 0; // Only first signal
        } else if (timestampCount === 3) {
            visible = signalCount < 2; // First and second signals
        } // else (1-2): all visible
    }

    return visible;
};

const getMSRSignalColor = (sensorAxisName) => {
    if (sensorAxisName.includes(BEARING_TYPES.NDE) || sensorAxisName.includes(BEARING_TYPES.DE)) {
        for (const bearingType of Object.keys(fftColorsMSR)) {
            if (sensorAxisName.includes(bearingType)) {
                for (const signal of Object.keys(fftColorsMSR[bearingType])) {
                    if (sensorAxisName.includes(signal)) {
                        return fftColorsMSR[bearingType][signal];
                    }
                }
            }
        }
    }
    return null;
};

// Helper function to get color based on sensor axis
export const getSignalColor = (sensorAxisName, fftDataIndex) => {
    if (sensorAxisName === fftSignals.Axial) {
        return fftColors.axialColors[fftDataIndex % fftColors.axialColors.length];
    }
    if (sensorAxisName === fftSignals.Tangential) {
        return fftColors.tangentialColors[fftDataIndex % fftColors.tangentialColors.length];
    }
    if (sensorAxisName === fftSignals.Radial) {
        return fftColors.radialColors[fftDataIndex % fftColors.radialColors.length];
    }
    const msrSignalColor = getMSRSignalColor(sensorAxisName);
    if (msrSignalColor) {
        return msrSignalColor;
    }

    return chartColors[0];
};

// Helper function to get signal name
export const getSignalName = (sensorAxisName) => {
    return sensorAxisName === PiezoSensor.axisName
        ? translate('ABB.Powertrain.Frontend.highFrequencyRadialLabel')
        : sensorAxisName;
};
